
import SuperAdminSidebar from "../components/super-admin/SuperAdminSidebar";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import AdminNavBar from "../components/admin/common/AdminNavBar";
import { Z_INDEX } from "../utils/constants";

const SuperAdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true); 

  const handleHamburgerClick = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  return (
    <div className="flex font-quicksand h-screen overflow-hidden bg-gray-50">
      <AdminNavBar handleHamburgerClick={handleHamburgerClick} />

      {/* Sidebar */}
      <div
        style={{ zIndex: Z_INDEX.sidebar }}
        className="fixed left-0 top-16 sm:top-18 md:top-20 bottom-0 "
      >
        <SuperAdminSidebar
          isSidebarOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          isSidebarExpanded={isSidebarExpanded}
          setIsSidebarExpanded={setIsSidebarExpanded}
        />
      </div>

      {/* Main content - Dynamic margin based on sidebar state */}
      <main
        style={{ zIndex: Z_INDEX.base }}
        className={`flex-1 mt-16 sm:mt-18 md:mt-20 overflow-y-auto relative transition-all duration-300 ${
          isSidebarExpanded ? "sm:ml-60" : "sm:ml-[5.3rem]"
        }`}
      >
        <div className="">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default SuperAdminLayout;
